import api from "@/api/api_instance";
import { AppResponse } from "@/types/app.types";

import { AuthEndpointsEnum } from "../constants/auth.endpoints";
import {
  GetOtpResponse,
  GetRelationUserParams,
  GetWebKeyResponse,
  UserDef,
} from "../types/auth.types";

export const fetchWebKey = (
  fingerprint: string
): Promise<GetWebKeyResponse> => {
  return api.get(AuthEndpointsEnum.WEB_KEY, {
    params: {
      fingerprint,
    },
  });
};

export const getCurrentUsername = (): Promise<UserDef> => {
  return api.get(AuthEndpointsEnum.PROFILE.replace(":id", "-1"));
};

export const getRelationUser = (
  params: GetRelationUserParams,
  signal: AbortSignal
): Promise<UserDef[]> => {
  return api.get(AuthEndpointsEnum.RELATIONSHIP, {
    params,
    signal,
  });
};

export const clearAuthToken = (): Promise<void> => {
  return api.get(AuthEndpointsEnum.LOGOUT);
};

export const getOtp = (): Promise<GetOtpResponse> => {
  return api.get(AuthEndpointsEnum.OTP);
};

export const getLibraryId = (): Promise<AppResponse<number>> => {
  return api.get(AuthEndpointsEnum.LIBRARY_ID);
};

export const fetchCookieSession = (
  fingerprint: string
): Promise<AppResponse<string>> => {
  return api.get(AuthEndpointsEnum.COOKIE_SESSION, {
    params: {
      fingerprint,
    },
  });
};
